const initialState = {
  projects: [],
  loading: false,
  loaded: false,
};

export const PROJECT_ACTION_ENUM = {
  UPDATE_PROJECTS: "update_projects",
  UPDATE_LOADING: "update_projects_loading",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_ACTION_ENUM.UPDATE_PROJECTS:
      return { projects: action.payload, loading: false, loaded: true };
    case PROJECT_ACTION_ENUM.UPDATE_LOADING:
      return { projects: [...state.projects], loading: true, loaded: false };
    default:
      return state;
  }
};

export default reducer;
